import { useState } from "react";

import {
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    List,
    IconButton,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FitnessCenterOutlinedIcon from "@mui/icons-material/FitnessCenterOutlined";
import CloseIcon from "@mui/icons-material/Close";

import { useAppSelector } from "app/hooks";
import { selectAllSites } from "./store/selectors";
import { EntityId } from "@reduxjs/toolkit";

export interface SiteListProps {
    activeSiteId?: EntityId;
    hideCloseButton?: boolean;
    onSiteSelected: (siteId: EntityId) => void;
    onSiteClosed: (siteId: EntityId) => void;
}

export function SiteList(props: SiteListProps) {
    const sites = useAppSelector(selectAllSites);

    const [open, setOpen] = useState(true);

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <>
            <ListItemButton onClick={handleClick}>
                <ListItemIcon>
                    <FitnessCenterOutlinedIcon />
                </ListItemIcon>
                <ListItemText primary="Clubs" />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse
                in={open}
                timeout="auto"
                unmountOnExit
            >
                <List
                    component="div"
                    disablePadding
                >
                    {sites.length === 0 && (
                        <ListItemButton>
                            <ListItemText>No clubs selected</ListItemText>
                        </ListItemButton>
                    )}

                    {sites.map((site) => (
                        <ListItemButton
                            key={site.id}
                            onClick={() => props.onSiteSelected(site.id)}
                            selected={props.activeSiteId === site.id}
                        >
                            <ListItemText primary={site.id} />
                            {!props.hideCloseButton && (
                                <IconButton
                                    onClick={(e) => {
                                        props.onSiteClosed(site.id);
                                        e.stopPropagation();
                                    }}
                                    edge="end"
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </ListItemButton>
                    ))}
                </List>
            </Collapse>
        </>
    );
}
